import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthServerProvider, IUser, UpdateUser } from 'app/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService as CUserService } from '../../services/user.service';
import { DataSharingService } from 'app/layouts/homepage/services/data-sharing.service';
import { CookieService } from 'ngx-cookie';
import { Subscription, timer } from 'rxjs';
import { PHONE_VALIDATION_ENABLED } from 'app/app.constants';

export enum PinType {
    MOBILE = 'SMS',
    EMAIL = 'EMAIL',
    ALT_MAIL = 'ALT_EMAIL'
}

@Component({
    selector: 'jhi-verify-otp',
    templateUrl: './verify-otp.component.html',
    styleUrls: ['../../../../../content/scss/styles.scss']
})
export class VerifyOtpComponent implements OnInit, OnDestroy {
    user: IUser;
    pinForm: FormGroup;
    submitted = false;
    errorCheck = false;
    emailChallenge: number;
    mobileChallenge: number;
    appUrl = '';
    successMsg: string;
    PinType = PinType;
    errorMsg = '';
    objectFromEditAccountInfo: IUser;
    isFirstLogin: boolean;
    countDown: Subscription;
    timeoutOTPActive: boolean;
    private subscriptionData: Subscription;

    phoneValidationEnabled: boolean = PHONE_VALIDATION_ENABLED;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private cUserService: CUserService,
        private dataSharing: DataSharingService,
        private jwtService: AuthServerProvider,
        private router: Router,
        private cookieService: CookieService
    ) {
        this.createForm();
        this.appUrl = this.route.snapshot.queryParamMap.get('appUrl');
    }

    ngOnInit() {
        this.subscriptionData = this.route.data.subscribe(routeData => {
            this.isFirstLogin = routeData.isFirstLogin;

            this.jwtService
                .authorize(this.isFirstLogin)
                .toPromise()
                .then(res => {
                    this.timeoutOTPActive = true;
                    this.countDown = null;

                    this.countDown = timer(0, 1000).subscribe(() => {
                        --this.cUserService.timeoutOTP;
                        if (this.cUserService.timeoutOTP <= 0) {
                            this.timeoutOTPActive = false;
                        }
                    });

                    this.objectFromEditAccountInfo = this.cUserService.getUserToVerify();
                });
        });
    }

    ngOnDestroy() {
        this.timeoutOTPActive = false;
        if(this.countDown) {
            this.countDown.unsubscribe;
        }
        if(this.subscriptionData) {
            this.subscriptionData.unsubscribe();
        }
    }

    private createForm() {
        this.pinForm = this.formBuilder.group({
            mobilePin: ['', [Validators.required]],
            emailPin: ['', [Validators.required]],
            emailAltPin: ['', [Validators.required]]
        });
    }

    get timeoutOTP() {
        return this.cUserService.timeoutOTP;
    }

    get f() {
        return this.pinForm.controls;
    }
    get fMobilePin() {
        return this.pinForm.get('mobilePin');
    }
    get fEmailPin() {
        return this.pinForm.get('emailPin');
    }
    get fEmailAltPin() {
        return this.pinForm.get('emailAltPin');
    }

    onSubmit() {
        this.errorCheck = true;
        // stop here if form is invalid
        // if (this.pinForm.invalid) {
        //     return;
        // }
        this.submitted = true;

        const outObj: IUser = Object.assign({}, this.objectFromEditAccountInfo);

        outObj.otpEmail = this.fEmailPin.value;
        outObj.otpAlternativeEmail = this.fEmailAltPin.value;
        outObj.otpPhone = this.fMobilePin.value;

        if (this.isFirstLogin) {
            // recupero i dati per cambio password
            const pwdToChange = this.cUserService.pwdtoChange;

            this.cUserService
                .changePassword(pwdToChange)
                .toPromise()
                .then(() => {
                    outObj.delay = true;

                    this.cUserService
                        .updateUser(outObj)
                        .toPromise()
                        .then(res => {
                            if (res && res.body && res.body.message) {
                                this.successMsg = res.body.message;
                            } else {
                                this.successMsg = 'Operazione effettuata con successo';
                            }
                        })
                        .catch(err => {
                            if (err && err.error) {
                                this.errorMsg = err.error.message;
                            }
                        })
                        .finally(() => {
                            this.submitted = false;
                        });
                })
                .catch(err => {
                    if (err && err.error) {
                        this.errorMsg = err.error.message;
                    }
                    this.submitted = false;
                });
        } else {
            this.cUserService
                .updateUser(outObj)
                .toPromise()
                .then(res => {
                    if (res && res.body && res.body.message) {
                        this.successMsg = res.body.message;
                    } else {
                        this.successMsg = 'Operazione effettuata con successo';
                    }
                })
                .catch(err => {
                    if (err && err.error) {
                        this.errorMsg = err.error.message;
                    }
                })
                .finally(() => {
                    this.submitted = false;
                });
        }
    }

    onReset() {
        this.submitted = false;
        this.pinForm.patchValue({
            mobilePin: '',
            emailPin: '',
            emailAltPin: ''
        });
    }

    private getInitData() {
        // this.userService.getLogged().toPromise().then(res => {
        //     this.user = res.body;
        //     this.populateForm();
        // }).catch(err => {
        //     console.log(err);
        // }).finally(() => {
        //     console.log('end');
        // });
        // this.populateChallenge(1234, 5678);
    }

    // private populateChallenge(mobileChallenge: number, emailChallenge: number) {
    //     this.mobileChallenge = mobileChallenge;
    //     this.emailChallenge = emailChallenge;
    // }

    backToApp() {
        this.router.navigate(['/']);
        // this.cUserService
        //     .isUserLoggedParams(this.appUrl)
        //     .toPromise()
        //     .then(res => {
        //         window.location.href = 'http://' + this.appUrl;
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     })
        //     .finally(() => {
        //         console.log('end');
        //     });
    }

    resendOtp(channel: string) {
        const outObj: IUser = Object.assign({}, this.objectFromEditAccountInfo);
        outObj.channelToResendOTP = channel;

        this.cUserService
            .reloadOTP(outObj)
            .toPromise()
            .then(res => {})
            .catch(err => {
                if (err && err.error) {
                    this.errorMsg = err.error.message;
                }
            })
            .finally(() => {
                this.submitted = false;
            });
    }

    redirect() {
        if (this.isFirstLogin) {
            const backUrl = this.cookieService.get('backUrl');
            if (backUrl) {
                window.location.href = backUrl;
            } else {
                this.router.navigate(['/']);
            }
        } else {
            this.router.navigate(['/']);
        }
    }

    redirectOnFailure() {
        if (this.isFirstLogin) {
            this.router.navigate(['/primoAccesso']);
        }
    }
}
